// Depends
import { group, subGroup, route, meta } from '@/helpers/routes'
import { routes as agenda } from './agenda'
import { routes as company } from './company'
import { routes as curriculum } from './curriculum'
import { routes as record } from './record'
import { routes as profile } from './profile'
import { routes as schedulings } from './schedulings'
import { routes as dashboard } from './dashboard'
import { routes as documents } from './documents'
import { routes as terms } from './terms'
import { routes as policy } from './privacy-policy'
import Config from './config/index'

const professionalAdvancedSettings = [
  route('/settings/config/index', '/settings/config/index', Config, meta('Profissional Configurações', true, 'guest'))
]

export default [
  ...group('/app/professional', [
    ...subGroup('/agenda', agenda),
    ...subGroup('/company', company),
    ...subGroup('/curriculum', curriculum),
    ...subGroup('/record', record),
    ...profile,
    ...schedulings,
    ...dashboard,
    ...documents,
    ...terms,
    ...policy,
    ...professionalAdvancedSettings
  ])
]



// WEBPACK FOOTER //
// ./src/app/professional/routes.js